import { WMItemDpLookupLayout, WMCodesLookupLayout, } from '../../../../common/lookups/Layouts/WMLayouts';
import { EDLookupLayout, EDHazardousLayout } from '../../../../common/lookups/Layouts/EDLayouts';
import {  IDConsigneeLookupLayout } from '../../../../common/lookups/Layouts/IdLayouts';
import { ABPopupMessageLayout } from '../../../../common/lookups/Layouts/ABLayouts';
import { ImItemLookupLayout,IMLocationLookupLayout,IMLotLookupLayout } from '../../../../common/lookups/Layouts/ImLayouts';
import { WM } from '../../../../const/constants';
import { LocationTypes } from '../../../../enum/Enum';
const runtimeParameter = JSON.stringify([
    { R_ITEM: 'R_ITEM' },{ R_IDENTITY: 'R_IDENTITY' },
]);
const loteCodes = IMLotLookupLayout({
    runtimeParameter
});
 
const eDLookupLayout = EDLookupLayout({ Dataelementnum: '355', Versionid: '4010' });
const classCodes = WMCodesLookupLayout({ codeType: '28' });
const subClassCodes = WMCodesLookupLayout({ codeType: '29' });
const physicalCountCodes = WMCodesLookupLayout({ codeType: '32' });
const popupMessageLayout = ABPopupMessageLayout({ tableName: 'IMSUBLOT' });
const imItemLookupLayout = ImItemLookupLayout({ itemType: 'S',moduleName: WM ,runtimeParameter });
const locationLookupLayout = IMLocationLookupLayout({ RWarehouse: null,moduleType: WM ,locationType :LocationTypes.StorageLocation});
const SearchLayout = [
    {
        "groupId": 1,
        "fields": [
            {
                "name": "RecordNumber",
                "tableName": "IMSUBLOT",
                "localizedField": "Keysequence",
                "label": "Record #",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "DateAvailableFrom",
                "tableName": "IMSUBLOT",
                "localizedField": "DateAvailableFrom",
                "label": "Available Date From",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    }, {
        "groupId": 2,
        "fields": [
            {
                "name": "ItemCode",
                "tableName": "IMSUBLOT",
                "localizedField": "ItemCode",
                "label": "Item",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "DateAvailableTo",
                "tableName": "IMSUBLOT",
                "localizedField": "DateAvailableTo",
                "label": "Available Date To",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    }, {
        "groupId": 3,
        "fields": [
            {
                "name": "LotCode",
                "tableName": "IMSUBLOT",
                "localizedField": "LotCode",
                "label": "Lot",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "DateIntroducedForm",
                "tableName": "IMSUBLOT",
                "localizedField": "DateIntroducedForm",
                "label": "Introduced Date Form",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    }, {
        "groupId": 4,
        "fields": [
            {
                "name": "SublotCode",
                "tableName": "IMSUBLOT",
                "localizedField": "SublotCode",
                "label": "SubLot",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "DateIntroducedTo",
                "tableName": "IMSUBLOT",
                "localizedField": "DateIntroducedTo",
                "label": "Introduced Date To",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    }
];

const PrimaryLayout = (lotLayout) => [
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "RECORD",
                "localizedField": "KEYSEQUENCE",
                "tableName": "IMSUBLOT",
                "label": "Record #",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            
            {
                "name": "R_ITEM",
                "tableName": "IMSUBLOT",
                "label": "Item",
                "type": "lookup",
                "layout": imItemLookupLayout,
                "required": true,
                "visible": true,
                "isLabelChanged": false,

            }
            ,
            {
                "name": "CustomerName",
                "tableName": "IMSUBLOT",
                "label": "Customer",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            }
            ,
            {
                "name": "R_LOT",
                "tableName": "IMSUBLOT",
                "label": "Lot",
                "type": "lookup",
                "layout": loteCodes,
                "required": true,
                "visible": true,
                "isLabelChanged": true,

            },
            {
                "name": "SUBLOTCODE",
                "tableName": "IMSUBLOT",
                "label": "Sublot",
                "type": "text",
                "required": true,
                "visible": true,
                "isLabelChanged": false,

            },
            {
                "name": "DESCRIPTION_1",
                "tableName": "IMSUBLOT",
                "label": "Description- 1",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,

            }
        ]
    },
    {
        "groupId": 2,
        "fields": [
            {
                "name": "DESCRIPTION_2",
                "tableName": "IMSUBLOT",
                "label": "Description- 2",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "STATUS",
                "tableName": "IMSUBLOT",
                "label": "Status",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,

            },
            {
                "name": "R_LOCATION",
                "tableName": "IMSUBLOT",
                "label": "Location",
                "type": "lookup",
                "layout": locationLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "DATEINTRODUCED",
                "tableName": "IMSUBLOT",
                "label": "Introduced Dt",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "DATEAVAILABLE",
                "tableName": "IMSUBLOT",
                "label": "Available Dt",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "DATEEXPIRATION",
                "tableName": "IMSUBLOT",
                "label": "Expiration Dt",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "COMMENT",
                "tableName": "IMSUBLOT",
                "label": "Comment",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false
            }

        ]
    }
]

const CodesLayout = [

    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "USERDEFINEDCODE_1",
                "localizedField": "USERDEFINEDCODE_1",
                "tableName": "IMSUBLOT",
                "label": "CODE 1",
                "type": "lookup",
                "layout": WMCodesLookupLayout({ codeType: '18' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_2",
                "localizedField": "USERDEFINEDCODE_2",
                "tableName": "IMSUBLOT",
                "label": "CODE 2",
                "type": "lookup",
                "layout": WMCodesLookupLayout({ codeType: '19' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_3",
                "localizedField": "USERDEFINEDCODE_3",
                "tableName": "IMSUBLOT",
                "label": "CODE 3",
                "type": "lookup",
                "layout": WMCodesLookupLayout({ codeType: '20' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_4",
                "localizedField": "USERDEFINEDCODE_4",
                "tableName": "IMSUBLOT",
                "label": "CODE 4",
                "type": "lookup",
                "layout": WMCodesLookupLayout({ codeType: '21' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_5",
                "localizedField": "USERDEFINEDCODE_5",
                "tableName": "IMSUBLOT",
                "label": "CODE 5",
                "type": "lookup",
                "layout": WMCodesLookupLayout({ codeType: '22' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_6",
                "localizedField": "USERDEFINEDCODE_6",
                "tableName": "IMSUBLOT",
                "label": "CODE 6",
                "type": "lookup",
                "layout": WMCodesLookupLayout({ codeType: '23' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_7",
                "localizedField": "USERDEFINEDCODE_7",
                "tableName": "IMSUBLOT",
                "label": "CODE 7",
                "type": "lookup",
                "layout": WMCodesLookupLayout({ codeType: '24' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_8",
                "localizedField": "USERDEFINEDCODE_8",
                "tableName": "IMSUBLOT",
                "label": "CODE 8",
                "type": "lookup",
                "layout": WMCodesLookupLayout({ codeType: '25' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_9",
                "localizedField": "USERDEFINEDCODE_9",
                "tableName": "IMSUBLOT",
                "label": "CODE 9",
                "type": "lookup",
                "layout": WMCodesLookupLayout({ codeType: '26' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_10",
                "localizedField": "USERDEFINEDCODE_10",
                "tableName": "IMSUBLOT",
                "label": "CODE 10",
                "type": "lookup",
                "layout": WMCodesLookupLayout({ codeType: '27' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }

        ]
    },
    {
        "groupId": 2,
        "label": "",
        "fields": [
            {
                "name": "USERDEFINEDDATE_1",
                "localizedField": "USERDEFINEDDATE_1",
                "tableName": "IMSUBLOT",
                "label": "Date 1",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_2",
                "localizedField": "USERDEFINEDDATE_2",
                "tableName": "IMSUBLOT",
                "label": "Date 2",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_3",
                "localizedField": "USERDEFINEDDATE_3",
                "tableName": "IMSUBLOT",
                "label": "Date 3",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_4",
                "localizedField": "USERDEFINEDDATE_4",
                "tableName": "IMSUBLOT",
                "label": "Date 4",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_5",
                "localizedField": "USERDEFINEDDATE_5",
                "tableName": "IMSUBLOT",
                "label": "Date 5",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_6",
                "localizedField": "USERDEFINEDDATE_6",
                "tableName": "IMSUBLOT",
                "label": "Date 6",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_7",
                "localizedField": "USERDEFINEDDATE_7",
                "tableName": "IMSUBLOT",
                "label": "Date 7",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_8",
                "localizedField": "USERDEFINEDDATE_8",
                "tableName": "IMSUBLOT",
                "label": "Date 8",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_9",
                "localizedField": "USERDEFINEDDATE_9",
                "tableName": "IMSUBLOT",
                "label": "Date 9",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_10",
                "localizedField": "USERDEFINEDDATE_10",
                "tableName": "IMSUBLOT",
                "label": "Date 10",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 3,
        "label": "",
        "fields": [
            {
                "name": "USERDEFINEDQUANTITY_1",
                "localizedField": "USERDEFINEDQUANTITY_1",
                "tableName": "IMSUBLOT",
                "label": "Quantity 1",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_2",
                "localizedField": "USERDEFINEDQUANTITY_2",
                "tableName": "IMSUBLOT",
                "label": "Quantity 2",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_3",
                "localizedField": "USERDEFINEDQUANTITY_3",
                "tableName": "IMSUBLOT",
                "label": "Quantity 3",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_4",
                "localizedField": "USERDEFINEDQUANTITY_4",
                "tableName": "IMSUBLOT",
                "label": "Quantity 4",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_5",
                "localizedField": "USERDEFINEDQUANTITY_5",
                "tableName": "IMSUBLOT",
                "label": "Quantity 5",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_6",
                "localizedField": "USERDEFINEDQUANTITY_6",
                "tableName": "IMSUBLOT",
                "label": "Quantity 6",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_7",
                "localizedField": "USERDEFINEDQUANTITY_7",
                "tableName": "IMSUBLOT",
                "label": "Quantity 7",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_8",
                "localizedField": "USERDEFINEDQUANTITY_8",
                "tableName": "IMSUBLOT",
                "label": "Quantity 8",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_9",
                "localizedField": "USERDEFINEDQUANTITY_9",
                "tableName": "IMSUBLOT",
                "label": "Quantity 9",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_10",
                "localizedField": "USERDEFINEDQUANTITY_10",
                "tableName": "IMSUBLOT",
                "label": "Quantity 10",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }

        ]
    }
]
const RefrencesLayout = [

    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "USERDEFINEDREFERENCE_1",
                "localizedField": "USERDEFINEDREFERENCE_1",
                "tableName": "IMSUBLOT",
                "label": "Reference 1",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE_2",
                "localizedField": "USERDEFINEDREFERENCE_2",
                "tableName": "IMSUBLOT",
                "label": "Reference 2",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE_3",
                "localizedField": "USERDEFINEDREFERENCE_3",
                "tableName": "IMSUBLOT",
                "label": "Reference 3",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE_4",
                "localizedField": "USERDEFINEDREFERENCE_4",
                "tableName": "IMSUBLOT",
                "label": "Reference 4",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE_5",
                "localizedField": "USERDEFINEDREFERENCE_5",
                "tableName": "IMSUBLOT",
                "label": "Reference 5",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE_6",
                "localizedField": "USERDEFINEDREFERENCE_6",
                "tableName": "IMSUBLOT",
                "label": "Reference 6",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE_7",
                "localizedField": "USERDEFINEDREFERENCE_7",
                "tableName": "IMSUBLOT",
                "label": "Reference 7",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE_8",
                "localizedField": "USERDEFINEDREFERENCE_8",
                "tableName": "IMSUBLOT",
                "label": "Reference 8",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE_9",
                "localizedField": "USERDEFINEDREFERENCE_9",
                "tableName": "IMSUBLOT",
                "label": "Reference 9",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE_10",
                "localizedField": "USERDEFINEDREFERENCE_10",
                "tableName": "IMSUBLOT",
                "label": "Reference 10",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }



        ]
    }
]
const StatusLayout = [
    {
        "groupId": 1,
        "label": "Quantity Status",
        "fields": [
            {
                "name": "BeginPeriod",
                "tableName": "IMITEM",
                "label": "Begin Period",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            }, {
                "name": "ON_HAND",
                "tableName": "IMITEM",
                "label": "On Hand",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            }, {
                "name": "IN_RECEIVING",
                "tableName": "IMITEM",
                "label": "In Receiving",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            }, {
                "name": "OUT_SHIPPED",
                "tableName": "IMITEM",
                "label": "In Shipping",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            }, {
                "name": "OUT_UNAVAILABLE",
                "tableName": "IMITEM",
                "label": "Unavailable",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            }, {
                "name": "AVAILABLE",
                "tableName": "IMITEM",
                "label": "Available",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            }, {
                "name": "IN_ORDERED",
                "tableName": "IMITEM",
                "label": "Pending Rec",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            }, {
                "name": "OUT_ORDERED",
                "tableName": "IMITEM",
                "label": "Pending Ship",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            }, {
                "name": "NETAVAILABLE",
                "tableName": "IMITEM",
                "label": "Net Available",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            }, {
                "name": "IN_FUTURE",
                "tableName": "IMITEM",
                "label": "Future Rec",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            }, {
                "name": "OUT_FUTURE",
                "tableName": "IMITEM",
                "label": "Future Ship",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            }
        ]
    },
    {
        "groupId": 2,
        "label": "Historical Information",
        "fields": [
            {
                "name": "INTRANSACTIONNUMBER",
                "tableName": "IMITEM",
                "label": "First Receipt",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,

            }
        ]
    }
]
const UOMLayout = [
    {
        "groupId": 1,
        "label": "Quantity Per Inventory Unit",
        "fields": [
            {
                "name": "UNITVOLUMEQUANTITY",
                "tableName": "IMITEM",
                "label": "Unit Volume",
                "type": "number",
                "format": "#,###0.0000",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UNITAREAQUANTITY",
                "tableName": "IMITEM",
                "label": "Unit Area",
                "type": "number",
                "format": "#,###0.0000",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
            ,
            {
                "name": "UNITVALUEQUANTITY",
                "tableName": "IMITEM",
                "label": "Unit Value",
                "type": "number",
                "format": "$ #,###0.0000",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
            ,
            {
                "name": "NETWEIGHT",
                "tableName": "IMITEM",
                "label": "Unit Net Wt",
                "type": "number",
                "format": "#,###0.0000",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
            ,
            {
                "name": "GROSSMINUSNET",
                "tableName": "IMITEM",
                "label": "Unit Tare Wt",
                "type": "number",
                "format": "#,###0.0000",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
            ,
            {
                "name": "GROSSWEIGHT",
                "tableName": "IMITEM",
                "label": "Unit Gross Wt",
                "type": "number",
                "format": "#,###0.0000",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 2,
        "label": "UOM",
        "fields": [
            {
                "name": "UNITVOLUMEUOM",
                "tableName": "IMITEM",
                "label": "Unit Volume",
                "type": "lookup",
                "layout": eDLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UNITAREAUOM",
                "tableName": "IMITEM",
                "label": "Unit Area",
                "type": "lookup",
                "layout": eDLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
            ,
            {
                "name": "UNITVALUEUOM",
                "tableName": "IMITEM",
                "label": "Unit Value",
                "type": "lookup",
                "layout": eDLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
            ,
            {
                "name": "NETWEIGHTUOM",
                "tableName": "IMITEM",
                "label": "Unit Net Wt",
                "type": "lookup",
                "layout": eDLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
            ,
            {
                "name": "",
                "tableName": "IMITEM",
                "label": "",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            }
            ,
            {
                "name": "GROSSWEIGHTUOM",
                "tableName": "IMITEM",
                "label": "Unit Gross Wt",
                "type": "lookup",
                "layout": eDLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    }, {
        "groupId": 3,
        "label": "Inventory Quantity Factors",
        "fields": [
            {
                "name": "INVENTORYUNITNOTUSED",
                "tableName": "IMITEM",
                "label": "Inventory Unit",
                "type": "number",
                "format": "#,###0.0000",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            },
            {
                "name": "PIECESPERUNITQUANTITY",
                "tableName": "IMITEM",
                "label": "Pieces/Unit",
                "type": "number",
                "format": "#,###0.0000",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
            ,
            {
                "name": "UNITSPERPACKAGEQUANTITY",
                "tableName": "IMITEM",
                "label": "Units/Pkg",
                "type": "number",
                "format": "#,###0.0000",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
            ,
            {
                "name": "PACKAGESPERSHIPPINGUNITQTY",
                "tableName": "IMITEM",
                "label": "Pkg/Ship",
                "type": "number",
                "format": "#,###0.0000",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 4,
        "label": "UOM",
        "fields": [
            {
                "name": "INVENTORYUNITUOM",
                "tableName": "IMITEM",
                "label": "Inventory Unit",
                "type": "lookup",
                "layout": eDLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "PIECESPERUNITUOM",
                "tableName": "IMITEM",
                "label": "Pieces/Unit",
                "type": "lookup",
                "layout": eDLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
            ,
            {
                "name": "UNITSPERPACKAGEUOM",
                "tableName": "IMITEM",
                "label": "Units/Pkg",
                "type": "lookup",
                "layout": eDLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
            ,
            {
                "name": "PACKAGESPERSHIPPINGUNITUOM",
                "tableName": "IMITEM",
                "label": "Pkg/Ship",
                "type": "lookup",
                "layout": eDLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    }, {
        "groupId": 5,
        "label": "Storage Billing",
        "fields": [
            {
                "name": "STORAGEBILLINGSTARTDATE",
                "tableName": "IMITEM",
                "localizedField": "STORAGEBILLINGSTARTDATE",
                "label": "Start",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "STORAGEBILLINGENDDATE",
                "tableName": "IMITEM",
                "localizedField": "STORAGEBILLINGENDDATE",
                "label": "End",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
            ,
            {
                "name": "STORAGEBILLEDDATE_LAST",
                "tableName": "IMITEM",
                "localizedField": "STORAGEBILLEDDATE_LAST",
                "label": "Last",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
            ,
            {
                "name": "PREVSTORAGEBILLEDDATE_LAST",
                "tableName": "IMITEM",
                "localizedField": "PREVSTORAGEBILLEDDATE_LAST",
                "label": "Previous Last",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            }
            ,
            {
                "name": "STORAGEBILLEDDATE_NEXT",
                "tableName": "IMITEM",
                "localizedField": "STORAGEBILLEDDATE_NEXT",
                "label": "Next",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,

            }
            ,
            {
                "name": "PREVSTORAGEBILLEDDATE_NEXT",
                "tableName": "IMITEM",
                "localizedField": "PREVSTORAGEBILLEDDATE_NEXT",
                "label": "Previous Next",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            }
            ,
            {
                "name": "RECURRINGSTORAGE",
                "tableName": "IMITEM",
                "localizedField": "RECURRINGSTORAGE",
                "label": "Recurring Flag",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    }, {
        "groupId": 6,
        "label": "Miscellaneous",
        "fields": [
            {
                "name": "SIZE_1",
                "tableName": "IMITEM",
                "label": "Size - 1",
                "type": "number",
                "format": "#,###0.0000",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "SIZE_2",
                "tableName": "IMITEM",
                "label": "Size - 2",
                "type": "number",
                "format": "#,###0.0000",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
            ,
            {
                "name": "ALTERNATEID",
                "tableName": "IMITEM",
                "localizedField": "ALTERNATEID",
                "label": "Alternate ID",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
            ,
            {
                "name": "R_CONSIGNEE",
                "tableName": "IMITEM",
                "label": "Consignee ID",
                "type": "lookup",
                "layout":IDConsigneeLookupLayout({valueExpr:'id',displayExpr:'identityid'}),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    }, {
        "groupId": 7,
        "label": "",
        "fields": [
            {
                "name": "POPUPMESSAGE",
                "tableName": "IMITEM",
                "label": "Popup Msg",
                "type": "lookup",
                "layout": popupMessageLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            } 
        ]
    }
]
export {
    SearchLayout,
    PrimaryLayout,
    CodesLayout,
    RefrencesLayout,
    StatusLayout,
    UOMLayout
}